import { render, staticRenderFns } from "./PlatformUserTable.vue?vue&type=template&id=e762a9e2"
import script from "./PlatformUserTable.vue?vue&type=script&lang=js"
export * from "./PlatformUserTable.vue?vue&type=script&lang=js"
import style0 from "./PlatformUserTable.vue?vue&type=style&index=0&id=e762a9e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports